import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};

  ${props =>
    props.error &&
    css`
      color: ${props.theme.colors.danger.onSurface};
    `}
`

export const CheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
`
